/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingemail2Inputs */

const en_profilebillingemail2 = /** @type {(inputs: Profilebillingemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email for invoices`)
};

const de_profilebillingemail2 = /** @type {(inputs: Profilebillingemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail für Rechnungen`)
};

/**
* | output |
* | --- |
* | "Email for invoices" |
*
* @param {Profilebillingemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingemail2 = /** @type {((inputs?: Profilebillingemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingemail2(inputs)
	return de_profilebillingemail2(inputs)
});
export { profilebillingemail2 as "profileBillingEmail" }